import { Link } from "react-router-dom";

export const sortAssignmentsByDueDate = (assignments = []) => [...assignments].sort((left, right) => {
  const leftDue = left.due_date || "";
  const rightDue = right.due_date || "";
  if (!leftDue && rightDue) return 1;
  if (leftDue && !rightDue) return -1;
  if (leftDue !== rightDue) return leftDue.localeCompare(rightDue);
  const createdOrder = (left.created_at || "").localeCompare(right.created_at || "");
  return createdOrder || (left.id || "").localeCompare(right.id || "");
});

const dueLabel = (dueDate) => {
  if (!dueDate) return "No due date";
  const [year, month, day] = dueDate.split("-").map(Number);
  if (!year || !month || !day) return dueDate;
  return new Intl.DateTimeFormat("en-US", {
    weekday: "long", month: "long", day: "numeric", year: "numeric", timeZone: "UTC",
  }).format(new Date(Date.UTC(year, month - 1, day)));
};

export const AssignmentDueGroups = ({ assignments, linkCards = false, testIdPrefix, title = "Open assignments", totalCount }) => {
  const ordered = sortAssignmentsByDueDate(assignments);
  const groups = ordered.reduce((result, assignment) => {
    const key = assignment.due_date || "none";
    if (!result[key]) result[key] = [];
    result[key].push(assignment);
    return result;
  }, {});

  if (!ordered.length) return null;
  return (
    <section data-testid={`${testIdPrefix}-section`}>
      <div className="mb-3 flex items-baseline gap-2">
        <h2 className="font-display text-xl font-semibold text-slate-900">{title}</h2>
        <span data-testid={`${testIdPrefix}-count`} className="text-sm text-slate-500">{totalCount ?? ordered.length}</span>
      </div>
      <div className="space-y-5" data-testid={`${testIdPrefix}-list`}>
        {Object.entries(groups).map(([dueDate, items]) => (
          <div key={dueDate} data-testid={`${testIdPrefix}-due-${dueDate}`}>
            <h3 className="mb-2 text-xs font-semibold uppercase tracking-widest text-slate-500">{dueLabel(dueDate === "none" ? "" : dueDate)}</h3>
            <div className="grid gap-2">
              {items.map((assignment) => {
                const content = (
                  <>
                    <div>
                      <div className="font-semibold text-slate-900">{assignment.title}</div>
                      <div className="text-xs text-slate-600">{assignment.subject} · due {dueLabel(assignment.due_date)}</div>
                    </div>
                    <span className="chip">{assignment.status}</span>
                  </>
                );
                return linkCards ? (
                  <Link key={assignment.id} to={`/assignments/${assignment.id}`} data-testid={`${testIdPrefix}-assignment-${assignment.id}`}
                    className="p-4 rounded-2xl bg-white border border-slate-200 flex items-center justify-between gap-3 hover:border-teal-300">
                    {content}
                  </Link>
                ) : (
                  <div key={assignment.id} data-testid={`${testIdPrefix}-assignment-${assignment.id}`}
                    className="p-4 rounded-2xl bg-amber-50 border border-amber-200 flex items-center justify-between gap-3">
                    {content}
                  </div>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};